import React from 'react'

function Home(){
    return(
        <section className='section'>
            <h2>Welcome to Ratna Vastra 💖</h2>

      <div className="section-divider"></div>

      <p>
        We offer beautiful sarees & trendy women's outfits designed to make you 
        look stylish, confident, and comfortable every day. Because you deserve 
        the best quality always ✨
      </p>
        </section>
    );
}
export default Home;